import { initializeApp, getApps } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAF6kIl8IRIentw4eWDCLxitEWjvYQ8tMc",
  authDomain: "rapidoladev.firebaseapp.com",
  databaseURL: "https://rapidoladev-default-rtdb.firebaseio.com",
  projectId: "rapidoladev",
  storageBucket: "rapidoladev.appspot.com",
  messagingSenderId: "517563732136",
  appId: "1:517563732136:web:bb0d3b61582478bb97f29d",
  measurementId: "G-YTC80T2LZ0"
};

if (!getApps().length) {
  initializeApp(firebaseConfig);
}

export const db = getFirestore();
export { firebaseConfig };
